class Proxies {

  constructor(basePath, apiClient) {

    this.basePath = `${basePath}`;
    this.apiClient = apiClient;

  }

  async createProxy(proxy) {

    const path = this.basePath + '/proxies';

    return this.apiClient.post(path, {}, {}, proxy);

  }

  async getAllProxies() {

    const path = this.basePath + '/proxies';

    return this.apiClient.get(path, {}, {});

  }

  async deleteProxyById(proxyId) {

    const path = this.basePath + '/proxies/:proxyId';

    return this.apiClient.delete(path, { proxyId }, {});

  }

}

export default Proxies;